import { combineEpics } from "redux-observable";
import { combineReducers } from "redux";
import {
  sentenceScoreOutReducer,
  inSentenceScoreEpic,
  midSentenceScoreEpic,
  outSentenceScoreEpic,
  keyPhraseReducer,
} from "./sentenceScoreEpics";
import { checkedCardReducerStepOne, checkedCardTitleReducerStepOne } from "./stepOneEpics";
import { checkedCardReducerStepTwo } from "./stepTwoEpics";
import {
  checkedTagsReducer,
  taxonomyPositionsEpic,
  taxonomyGroupsEpic,
  taxonomyReducer,
  taxonomyColorReducer,
  taxonomyTagsAndPositionsReducer,
} from "./stepThreeEpics";
import { pageNumberReducer } from "./pageNumberEpic";
import { cameraRotationReducer, cameraZReducer } from "./cameraEpic";
import {
  addKeyphraseEpic,
  addKeyphrasesEpic,
  removeKeyphraseEpic,
  connectorEpic,
  groupReducer,
  connectorReducer,
} from "./canvasEpics";

export const rootEpic = combineEpics(
  inSentenceScoreEpic,
  midSentenceScoreEpic,
  outSentenceScoreEpic,
  taxonomyPositionsEpic,
  taxonomyGroupsEpic,
  addKeyphraseEpic,
  addKeyphrasesEpic,
  removeKeyphraseEpic,
  connectorEpic,
);

export const rootReducer = combineReducers({
  sentenceScore: sentenceScoreOutReducer,
  pageNumber: pageNumberReducer,
  checkedCardStepOne: checkedCardReducerStepOne,
  checkedCardTitle: checkedCardTitleReducerStepOne,
  checkedCardStepTwo: checkedCardReducerStepTwo,
  keyphrases: keyPhraseReducer,
  checkedTags: checkedTagsReducer,
  taxonomyGroups: taxonomyReducer,
  taxonomyGroupColors: taxonomyColorReducer,
  taxonomyTagsAndPositions: taxonomyTagsAndPositionsReducer,
  cameraRotation: cameraRotationReducer,
  cameraZ: cameraZReducer,
  group: groupReducer,
  connectors: connectorReducer,
});
